'use client';

import { cn } from '@core/utils';
import type { HomeGiftProductDto } from '@generated/unauth';

import { GiftListItem } from '@/app/_components/DonationTemp/GiftListItem';
import { GIFT_SALE_STATUS } from '@/app/donation/constants';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';

interface GiftListProps {
  items: HomeGiftProductDto[];
}

export const GiftList = ({ items }: GiftListProps) => {
  const handleGiftLinkClick = (item: HomeGiftProductDto) => {
    trackGtmEvent(GTM_EVENT_TYPE.SELECT_ITEM, {
      currency: 'KRW',
      value: item.requiredDonationAmount,
      local_name: item.institutionName,
      items: [
        {
          item_type: '답례품',
          item_list_name: '상품 상세 하단',
          item_list_id: item.productNumber,
          price: item.requiredDonationAmount,
          item_name: item.productName,
          quantity: 1,
          item_id: item.productNumber,
        },
      ],
    });
  };

  return (
    <ul
      className={cn(
        'grid grid-cols-4 gap-x-15 gap-y-33',
        'mobile-tablet:grid-cols-2',
      )}
    >
      {items.map((product) => (
        <li key={product.productNumber}>
          <GiftListItem
            productNumber={product.productNumber}
            mainImageSizes={`${BREAKPOINTS.MOBILE_TABLET} 50vw, 288px`}
            mainImageUrl={product.mainImageUrl}
            productName={product.productName}
            donationAmount={product.requiredDonationAmount}
            reviewRating={product.reviewRating}
            reviewCount={product.reviewCount}
            isSoldOut={product.productSaleStatus === GIFT_SALE_STATUS.SOLD_OUT}
            isAdult={product.adultYN}
            institution={{
              id: product.institutionId,
              logoUrl: product.institutionLogoUrl,
              name: product.institutionName,
            }}
            onGiftLinkClick={() => handleGiftLinkClick(product)}
            isNew={product.newDisplayYN}
            responsiveClassName={{
              institutionLogo: 'mobile-tablet:size-20',
              institutionName:
                'mobile-tablet:typo-caption1 mobile-tablet:font-600',
              productName: 'mobile-tablet:typo-body4 mobile-tablet:font-500',
              donationAmount: 'mobile-tablet:typo-body3 mobile-tablet:font-700',
              donationAmountText:
                'mobile-tablet:typo-body4 mobile-tablet:font-600',
            }}
          />
        </li>
      ))}
    </ul>
  );
};
